import { DateRange } from "@/domains/common";
// components
import { Button } from "antd";

export const DateRangeButtonGroup = ({
  dateRange,
  onChange,
}: {
  dateRange: DateRange;
  onChange: (v: any) => void;
}) => {
  const dateRangeButtons = [
    {
      label: "今天",
      value: DateRange.day0,
    },
    {
      label: "昨天",
      value: DateRange.day1,
    },
    {
      label: "本周",
      value: DateRange.week0,
    },
    {
      label: "上周",
      value: DateRange.week1,
    },
    {
      label: "本月",
      value: DateRange.month0,
    },
    {
      label: "上月",
      value: DateRange.month1,
    },
  ];

  return (
    <div className="mt:24 flex jc:center ai:center gap:16">
      {dateRangeButtons.map(({ label, value }) => (
        <Button
          type={dateRange === value ? "primary" : "default"}
          onClick={() => onChange(value)}
          key={value}
        >
          {label}
        </Button>
      ))}
    </div>
  );
};
